module.exports = __webpack_public_path__ + "static/media/nav-logo.e291468e.png";